import { useState, useEffect } from "react";

const sections = ["Home", "About", "Products", "Features", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("Home");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      const offsets = sections.map((s) => {
        const el = document.getElementById(s.toLowerCase());
        return { id: s, top: el ? el.getBoundingClientRect().top : Infinity };
      });
      const current = offsets.filter((o) => o.top <= 120).pop();
      if (current) setActive(current.id);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("home")}>
          <img
            src="https://public.readdy.ai/ai/img_res/d7cd33cb-b3f6-4ecd-9edd-36b11e99cf63.png"
            alt="CERTROM SRL Logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-bold text-lg tracking-wide transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            CERTROM SRL
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {sections.map((s) => (
            <button
              key={s}
              onClick={() => scrollTo(s)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                active === s
                  ? scrolled
                    ? "text-gray-900 border-b-2 border-gray-900 pb-0.5"
                    : "text-white border-b-2 border-white pb-0.5"
                  : scrolled
                  ? "text-gray-500 hover:text-gray-900"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {s}
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
          <span className={`block w-4 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {sections.map((s) => (
            <button
              key={s}
              onClick={() => scrollTo(s)}
              className="text-left text-sm font-medium text-gray-700 hover:text-gray-900 cursor-pointer whitespace-nowrap"
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
